import scope from "./scope"
import GroupingResult from 'state/Constants/GroupingResult';

import { selectBaseGroupingParams } from "state/selections/selector";
import SelectionState from 'state/selections/SelectionState';
import { selectDefinitions } from 'state/scenarioAnalysis/selectors';
import { SummaryType } from '@ls/grouping-service';
import { exchange } from '@ls/js-fetch';
import { splitByCalcTypeScenario } from 'state/util';
export const SET_DEFINITION = `${scope}/SET_DEFINITION`;
export const setDefinition = (idx, definition) => ({
    type: SET_DEFINITION,
    idx,
    definition,
});

export const SET_DEFINITIONS = `${scope}/SET_DEFINITIONS`;
export const setDefinitions = (definitions) => ({
    type: SET_DEFINITIONS,
    definitions,
});
export const DELETE_DEFINITION = `${scope}/DELETE_DEFINITION`;
export const REQUEST_SCENARIO_ANALYSIS_DATA = `${scope}/REQUEST_SCENARIO_ANALYSIS_DATA`;
export const RECEIVE_SCENARIO_ANALYSIS_DATA = `${scope}/RECEIVE_SCENARIO_ANALYSIS_DATA`;
export const REQUEST_SCENARIO_ANALY_SBS_DATA = `${scope}/REQUEST_SCENARIO_ANALY_SBS_DATA`;
export const RECEIVE_SCENARIO_ANALY_SBS_DATA = `${scope}/RECEIVE_SCENARIO_ANALY_SBS_DATA`;
export const requestGridData = () => {
    return async (dispatch, getState) => {
        const state = getState();
        const definitions = selectDefinitions(SelectionState.COMMITTED)(state);
        if (!definitions?.length) {
            return;
        }

        const [absDefinitions, bmkDefinitions, relDefinitions] = splitByCalcTypeScenario(definitions);

        const makeRequest = async (summary, definitions, benchesToo) => {
            dispatch({ type: REQUEST_SCENARIO_ANALYSIS_DATA, summary });
            const groupingResults = [];

            groupingResults.push(GroupingResult.SCENARIOS);
            const url = process.env.REACT_APP_BASE_URL_GROUPING_SERVICE;

            //const getBaseGroupingParams = selectGetBaseGroupingParams(state);
            const [baseParams, sbsParams] = selectBaseGroupingParams(state);

            dispatch({
                type: RECEIVE_SCENARIO_ANALYSIS_DATA,
                summary,
                data: (await exchange({
                    params: {
                        ...baseParams,
                        results: baseParams.results + ",SCENARIOS",
                        summary,
                        benchesToo,
                        scenario_factors: [...new Set(definitions.map(({ scenarioAnalysisFactor }) => scenarioAnalysisFactor))].join(','),
                        scenario_ids: [...new Set(definitions.map(({ scenarioAnalysisId }) => scenarioAnalysisId))].join(','),
                        scenario_values: [...new Set(definitions.map(({ scenarioType }) => scenarioType))].join(',')
                    },
                    url,
                    cancelId: `data-${scope}-${summary}`,
                }))?.data,
            });

            if (sbsParams) {
                dispatch({ type: REQUEST_SCENARIO_ANALY_SBS_DATA, summary });
                dispatch({
                    type: RECEIVE_SCENARIO_ANALY_SBS_DATA,
                    summary,
                    data: (
                        await exchange({
                            url,
                            params: {
                                ...sbsParams,
                                results: baseParams.results + ",SCENARIOS",
                                summary,
                                benchesToo,
                                scenario_factors: [...new Set(definitions.map(({ scenarioAnalysisFactor }) => scenarioAnalysisFactor))].join(','),
                                scenario_ids: [...new Set(definitions.map(({ scenarioAnalysisId }) => scenarioAnalysisId))].join(','),
                                scenario_values: [...new Set(definitions.map(({ scenarioType }) => scenarioType))].join(',')

                            },
                            cancelId: `data-sbs-${scope}-${summary}`,
                        })
                    )?.data,
                });
            }

        };
        if (absDefinitions.length || bmkDefinitions.length) {
            makeRequest(
                SummaryType.ABSOLUTE,
                [...absDefinitions, ...bmkDefinitions],
                bmkDefinitions.length > 0,
            ).then();
        }

        if (relDefinitions.length) {
            makeRequest(
                SummaryType.RELATIVE,
                relDefinitions,
                true,
            ).then();
        }

    }
};